import { Component, Input, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/shared/services/general.service';


@Component({
    selector: 'expenses',
    templateUrl: './expenses.component.html',
    styleUrls: ['./expenses.component.scss']
})
export class ExpensesComponent implements OnInit {

    @Input() info : any;

    data : any = [];

    constructor( 
        protected gs : GeneralService
    ){
    }  
    
    ngOnInit(){
        this.info?.expenses?.map(item =>{
            if(item.amount > 0 && item.amount !='0,00'){
                let tag = this.gs.getTags('expenses',false, item.tag);
                
                item.title = tag.tag;
                item.sort = tag.attr.sort;
                item.period = item.period?.toLowerCase();

                this.data.push(item);
            }
        });
        this.data = this.data.sort((a,b) => a?.sort - b?.sort);
    }

}